import { IMPROVE_CONFIG } from "@/config.js";
import axios from "axios";

export default {
  sendEmail: function(email) {
    return axios.post(IMPROVE_CONFIG.API_URL + "/user/send-email", {
      subject: email.subject,
      email: email.email,
      content: email.content
    });
  },
};